import React, { useState, useEffect, useRef } from 'react';
import { Header as HeaderBernie } from '@gc/global-components';

import { GlobalNavigationLineOfBusiness } from 'src/common/__generated__/api/types';

//components
import { ProgressBar } from './progress-bar/progress-bar';
import SubHeader from './sub-header/sub-header';
import { useStores } from 'src/utils/useStore';
import { checkValue } from 'src/components/common/helper';
import PartnerSubHeader from './partner-sub-header/partner-sub-header';
import { SubHeaderProps } from './global-header.d';
import { ModuleProps } from 'src/components/concierge/util/module-util';
import { ConciergeInforBarComponent } from 'src/components/concierge/modules/Common/InfoBar/code-split/infobar-component';
import SubHeadervariant2 from './sub-header/sub-header-v2';

export interface HeaderProps {
  className?: string;
  isSubHeader?: boolean;
  subHeaderProps?: SubHeaderProps;
  isPartnerHeader?: boolean;
  progressBarType? : 'v1' | 'v2'
}
export const GlobalHeader: React.FC<HeaderProps> = ({
  className = '',
  isSubHeader = false,
  subHeaderProps,
  isPartnerHeader = false,
  progressBarType = 'v1'
}) => {
  const {
    cpcmslitefeed: { cpCmsLitePageData, spotlightPageData, conciergePageData },
  } = useStores();
 
  const [isInfoBarOpen, toggleOpenInfoBar] = useState(false);
  const ref = useRef(null)
  let scrolling: boolean;
  let position = 0;
  const delta = 5;

  const topHeaderProps = {
    props: {} as ModuleProps,
    isActive: true,
    toggleOpenInfoBar: (d) => toggleOpenInfoBar(d),
  };

  const lozengeDetailMessage = checkValue(cpCmsLitePageData)
  ? cpCmsLitePageData?.lozengeDetailMessage
  : checkValue(spotlightPageData)
  ? spotlightPageData?.lozengeDetailMessage
  : checkValue(conciergePageData)
  ? conciergePageData?.lozengeDetailMessage
  : '';

  const lozengeTextColor = checkValue(cpCmsLitePageData)
  ? cpCmsLitePageData?.lozengeTextColor
  : checkValue(spotlightPageData)
  ? spotlightPageData?.lozengeTextColor
  : checkValue(conciergePageData)
  ? conciergePageData?.lozengeTextColor
  : '';

  const lozengeBackgroundColor = checkValue(cpCmsLitePageData)
  ? cpCmsLitePageData?.lozengeBackgroundColor
  : checkValue(spotlightPageData)
  ? spotlightPageData?.lozengeBackgroundColor
  : checkValue(conciergePageData)
  ? conciergePageData?.lozengeBackgroundColor
  : '';

  const lozengeIconStyle = checkValue(cpCmsLitePageData)
  ? cpCmsLitePageData?.lozengeIconStyle
  : checkValue(spotlightPageData)
  ? spotlightPageData?.lozengeIconStyle
  : checkValue(conciergePageData)
  ? conciergePageData?.lozengeIconStyle
  : '';

  const lozengeIconColor = checkValue(cpCmsLitePageData)
  ? cpCmsLitePageData?.lozengeIconColor
  : checkValue(spotlightPageData)
  ? spotlightPageData?.lozengeIconColor
  : checkValue(conciergePageData)
  ? conciergePageData?.lozengeIconColor
  : '';

  // Need to fix this
  // To do
  const secondaryColour = checkValue(cpCmsLitePageData)
    ? cpCmsLitePageData?.secondaryColour
    : checkValue(spotlightPageData)
    ? spotlightPageData?.secondaryColour
    : checkValue(conciergePageData)
    ? conciergePageData?.secondaryColor
    : '';

  const turnOffHeader = checkValue(cpCmsLitePageData)
    ? cpCmsLitePageData?.turnOffHeader
    : checkValue(spotlightPageData)
    ? spotlightPageData?.turnOffHeader
    : checkValue(conciergePageData)
    ? conciergePageData?.turnOffHeader
    : '';

  const templateType = checkValue(cpCmsLitePageData)
    ? cpCmsLitePageData?.templateType
    : checkValue(spotlightPageData)
    ? spotlightPageData?.templateType
    : checkValue(conciergePageData)
    ? conciergePageData?.templateType
    : '';
  
  const turnOffSubheader = checkValue(cpCmsLitePageData)
  ? cpCmsLitePageData?.turnOffSubheader
  : checkValue(spotlightPageData)
  ? spotlightPageData?.turnOffSubheader
  : checkValue(conciergePageData)
  ? conciergePageData?.turnOffSubheader
  : '';
  
  const turnOffSubHeaderHamburgerMenu = checkValue(cpCmsLitePageData)
  ? cpCmsLitePageData?.turnOffSubHeaderHamburgerMenu
  : checkValue(spotlightPageData)
  ? spotlightPageData?.turnOffSubHeaderHamburgerMenu
  : checkValue(conciergePageData)
  ? conciergePageData?.turnOffSubHeaderHamburgerMenu
  : '';

  const turnOffProgressBar = checkValue(cpCmsLitePageData)
  ? cpCmsLitePageData?.turnOffProgressBar
  : checkValue(spotlightPageData)
  ? spotlightPageData?.turnOffProgressBar
  : checkValue(conciergePageData)
  ? conciergePageData?.turnOffProgressBar
  : '';

  const isHamburgerMenu = turnOffSubHeaderHamburgerMenu?.toLowerCase() === 'true';

  const hideSubHeader = turnOffSubheader?.toLowerCase() === 'true';

  const isHeaderTurnOff = turnOffHeader?.toLowerCase() === 'true'; 

  const isProgressBarTurnOff = turnOffProgressBar?.toLowerCase() === 'true'; 

  const isInfoBarActive = checkValue(conciergePageData);

  useEffect(() => {
    if (subHeaderProps?.variant === "v2") {
        const scrollStart = () => {
          scrolling = true
        }
        window.addEventListener('scroll', scrollStart, { passive: true });
        return () => {
          window.removeEventListener('scroll', scrollStart);
        }
    }
  }, []);

  setInterval(function() {
    if (scrolling) {
      scrollFunction();
      scrolling = false;
    }
  }, 250);

  const scrollFunction = () => {
    const infoBar = document?.querySelector<HTMLElement>('.info-region');
    const elementHeight = ref.current.clientHeight || 128;
    const srollHeight = window?.pageYOffset || 0;

    if (infoBar === null) return;
    if (Math.abs(position - srollHeight) <= delta) return;

    if (srollHeight > position && srollHeight > elementHeight) {
      infoBar.classList.add('z-index-1-opacity');
      infoBar.classList.remove('z-index-0-opacity');
      setTimeout(() => {
        infoBar.classList.remove('scroll-down');
        infoBar.classList.add('scroll-up');
      }, 10);
    } else {
      if (srollHeight < elementHeight) {
        infoBar.classList.remove('scroll-up');
        infoBar.classList.add('scroll-down');
        setTimeout(() => {
          infoBar.classList.remove('z-index-1-opacity');
          infoBar.classList.add('z-index-0-opacity');
        }, 200);
      }
    }
    position = srollHeight;
  }
  return (
    <section ref={ref} className={`header-main-container ${className} ${isInfoBarOpen ? 'infoBar-open' : 'infoBar-close'} ${hideSubHeader ? 'subHeader-close' : 'subHeader-open'}`}>
      {isInfoBarActive && <ConciergeInforBarComponent {...topHeaderProps} />}
      {!isHeaderTurnOff && (
        <HeaderBernie
          className={`priamary-site-header page-header_${templateType}`}
          lineOfBusiness={GlobalNavigationLineOfBusiness.UNKNOWN}
        />
      )}

        {checkValue(subHeaderProps?.variant) && subHeaderProps?.variant === "v2" ? (
            <>
            {isSubHeader && <SubHeadervariant2 {...{...subHeaderProps, lozengeDetailMessage, isHamburgerMenu, lozengeTextColor, lozengeBackgroundColor, lozengeIconStyle, lozengeIconColor}}/>}
            </>
        ) : (
          <>
            {!hideSubHeader && isSubHeader ? <SubHeader {...{...subHeaderProps, isHeaderTurnOff, lozengeDetailMessage, isHamburgerMenu, lozengeTextColor, lozengeBackgroundColor, lozengeIconStyle, lozengeIconColor}} /> : null}
            {!hideSubHeader && isPartnerHeader ? <PartnerSubHeader {...{...subHeaderProps, lozengeDetailMessage, isHamburgerMenu, lozengeTextColor, lozengeBackgroundColor, lozengeIconStyle, lozengeIconColor}} /> : null }
          </>
        )}             
      { !isProgressBarTurnOff && <ProgressBar secondaryColour={secondaryColour} progressBarType={progressBarType}/> }
    </section>
  );
};

export default GlobalHeader;
